import { atom } from "recoil";

export const interpreteLangState = atom({
  key: "interpreteLangState",
  default: "sr",
});
